import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BillingsComponent } from './billings.component';
import { UpgradePackageComponent } from './pages/upgrade-package/upgrade-packages.component';
import { ChoosePackageComponent } from './pages/choose-package/choose-package.component';

const routes: Routes = [
  { path: '', component: BillingsComponent },
  { path: 'upgrade-package', component: UpgradePackageComponent },
  { path: 'upgrade-package/choose-package', component: ChoosePackageComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BillingsRoutingModule {}
